//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Button'

export default {
  name: 'Heading',

  components: {
    Button
  },

  props: {
    type: {
      type: String,
      default() {
        return 'page'
      }
    },
    title: String,
    titleLight: String,
    subtitle: String,
    subtitleIcon: String,
    tabs: Array,
    closeHint: String,
    hideNav: {
      type: Boolean,
      default() {
        return true
      }
    }
  },

  data() {
    return {
      isNavigationMenuOpen: false
    }
  },

  computed: {
    isMobile() {
      return this.$store.getters.isMobile
    },
    isTabs() {
      return this.tabs && !this.isMobile
    },
    outerClass() {
      return `swoopHeading type-${this.type} ${this.isTabs ? 'isTabs' : ''}`
    }
  }
}
